export default "__VITE_ASSET__bbb7945f__"